import React, { Fragment, useState } from "react"
import { BsPrinter } from "react-icons/bs"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { printOrder } from "utils"
import { Button, Checkbox, IconButton, Modal } from "components"
import classes from "./OrderDetailsThermalPrintButton.module.scss"

const OrderDetailsThermalPrintButton = props => {
  const { order } = props

  const [t, i18n] = useTranslation()

  const printers = useSelector(state => state.printers)

  const [sending, setSending] = useState(false)
  const [openPrintersModal, setOpenPrintersModal] = useState(false)
  const [selectedPrinters, setSelectedPrinters] = useState([])

  const handleCheckbox = (checked, printer) => {
    setSelectedPrinters(prev =>
      checked
        ? [...prev, printer]
        : prev.filter(p => p._id !== printer._id)
    )
  }

  const handleExited = () => {
    setSelectedPrinters([])

    setSending(false)
  }

  const handlePrintOrder = async () => {
    setSending(true)

    const skipKitchenReceipt = false

    const skipOrderItems = false

    try {
      await printOrder(
        order,
        skipKitchenReceipt,
        skipOrderItems,
        selectedPrinters.length !== 0 ? selectedPrinters : undefined
      )

      setOpenPrintersModal(false)
    } catch (err) {
      toast.error(t("پرینت_انجام_نشد"))
    }
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div
        className={classes["container"]}
        onClick={() =>
          printers.length === 1
            ? handlePrintOrder()
            : setOpenPrintersModal(true)
        }
      >
        <IconButton
          loading={sending}
          icon={BsPrinter}
          size={18}
          loadingColor="black"
        />
        <span
          className={clsx(
            classes["text"],
            isLtr && classes["text-ltr"]
          )}
        >
          {t("پرینت_حرارتی_رسید")}
        </span>
      </div>

      <Modal
        size="sm"
        show={openPrintersModal}
        onHide={() => setOpenPrintersModal(false)}
        onExited={handleExited}
      >
        <div className={classes["modal"]}>
          <div className={classes["title"]}>
            {t("پرینتر_های_خود_را_انتخاب_کنید")}
          </div>

          {printers.map((printer, index) =>
            <div
              key={index}
              className={classes["card"]}
            >
              <span className={classes["name"]}>
                {printer.printerName}
              </span>

              <Checkbox
                checked={selectedPrinters.some(p => p._id === printer._id)}
                onChange={(checked) => handleCheckbox(checked, printer)}
              />
            </div>
          )}

          <div className={classes["footer"]}>

            <Button
              color="danger"
              onClick={() => setOpenPrintersModal(false)}
            >
              {t("لغو")}
            </Button>

            <Button
              color="success"
              loading={sending}
              onClick={handlePrintOrder}
              disabled={selectedPrinters.length === 0}
              className={clsx(
                classes["button"],
                isLtr && classes["button-ltr"]
              )}
            >
              {t("پرینت")}
            </Button>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}

export default OrderDetailsThermalPrintButton